import { FormattedMessage } from 'react-intl'
import ImagesComponent from '../../../../../components/ImagesRow'
import TeamContactsComponent from '../../../../../components/TeamContactsRow'
import GameItem from '../components/game-item/game-item'
import banerAsia from '../../../../../assets/images/event-asia-baner.png'

export const createEventSectionsConfig = (event, conditions, styles) => {
  const countriesList = (() => {
    if (!conditions.hasCountries) return null
    return event.countries.map((el, index) => (
      <p key={index} className={styles.about__data__description}>
        {el}
      </p>
    ))
  })()

  const gamesList = (() => {
    if (!conditions.hasGames) return null

    return event.games.games.map((el, index) => (
      <GameItem
        key={index}
        title={el?.title ? el?.title : 'Game'}
        logo={el?.logo ? el?.logo : banerAsia}
      />
    ))
  })()

  return [
    {
      key: 'information',
      wrapper: 'SectionWrapper',
      title: (
        <h4 className={styles.events__about__title}>
          <FormattedMessage id='tournaments.details.info.tabs.information' />
        </h4>
      ),
      children: (
        <>
          {conditions.hasDescription && (
            <p className={styles.events__about__description}>
              {event.description}
            </p>
          )}
          {conditions.hasGrade && (
            <p className={styles.events__about__description}>
              <FormattedMessage id='match.ticker.layer' /> : {event.grade}
            </p>
          )}
          {conditions.hasCountries && (
            <div className={styles.events__about__data}>
              <p className={styles.about__data__title}>
                <FormattedMessage id='community.list.description.country ' /> :
              </p>
              {countriesList}
            </div>
          )}
        </>
      ),
    },
    {
      key: 'games',
      condition: 'hasGames',
      titleId: 'community.list.description.games',
      children: (
        <div className={styles.events__games__container}>{gamesList}</div>
      ),
    },
    {
      key: 'organizer-logo',
      condition: 'hasOrganizerLogo',
      component: ImagesComponent,
      props: {
        organizerLogo: true,
        images: event.organizerLogo,
      },
    },
    {
      key: 'team-of-organizer',
      condition: 'hasTeamOfOrganizer',
      component: TeamContactsComponent,
      props: {
        teamOfOrganizer: true,
        information: event.teamOfOrganizer,
      },
    },
    {
      key: 'contacts',
      condition: 'hasContacts',
      component: TeamContactsComponent,
      props: {
        contacts: true,
        information: event.contacts,
      },
    },
    {
      key: 'partner-logo',
      condition: 'hasPartnerLogo',
      component: ImagesComponent,
      props: {
        partnerLogo: true,
        images: event.partnerLogo,
      },
    },
    {
      key: 'sponsor-logo',
      condition: 'hasSponsorLogo',
      component: ImagesComponent,
      props: {
        sponsorLogo: true,
        images: event.sponsorLogo,
      },
    },
    {
      key: 'any-photos',
      condition: 'hasAnyPhotos',
      component: ImagesComponent,
      props: {
        anyPhotos: true,
        images: event.anyPhotos,
      },
    },
  ]
}
